export enum TaskStatusEnum {
  Pending = "pending",
  Active = "active",
  Retrying = "retrying",
  FullDone = "fullDone",
  WarnDone = "warnDone",
  PartDone = "partDone",
  Failed = "failed",
  Cancelled = "cancelled",
  /** 已审核：FullDone 经审核闭环后的终态，仅由审核服务显式写入，不参与执行态汇总 */
  Reviewed = "reviewed",
}

export enum TaskLogTypeEnum {
  StatusChange = "statusChange",
  ProgressUpdate = "progressUpdate",
  Error = "error",
  Retry = "retry",
  Cancel = "cancel",
  Info = "info",
  Warn = "warn",
}
